(() => {
  'use strict';

  const safeParse = (value, fallback = []) => {
    try { const parsed = JSON.parse(value); return Array.isArray(parsed) ? parsed : fallback; }
    catch (_) { return fallback; }
  };

  const init = (root) => {
    if (!root || root.dataset.zeroReviewsReady === 'true') return;
    root.dataset.zeroReviewsReady = 'true';

    const form = root.querySelector('.zero-reviews__form');
    const pendingWrap = root.querySelector('[data-zero-pending]');
    const pendingGrid = root.querySelector('[data-zero-pending-grid]');
    const message = root.querySelector('[data-zero-review-message]');
    const externalGrid = root.querySelector('[data-zero-external-grid]');
    const emptyState = root.querySelector('[data-zero-empty]');
    const scoreBox = root.querySelector('[data-zero-score]');
    const pendingClear = root.querySelector('[data-zero-pending-clear]');
    const key = root.dataset.storageKey || 'zero-reviews-v72';
    const legacyKey = (root.dataset.legacyStorageKey || '').trim();
    const resetAll = root.querySelector('[data-zero-review-reset-all]');
    const bodyInput = root.querySelector('[data-zero-review-body]');
    const bodyCount = root.querySelector('[data-zero-review-count]');
    const mode = root.dataset.submissionMode || 'shopify_contact';
    const endpoint = (root.dataset.externalEndpoint || '').trim();
    const pendingStatusText = (root.dataset.pendingStatus || 'WARTET AUF FREIGABE').trim();
    const pendingRemoveText = (root.dataset.pendingRemove || 'DIESE BEWERTUNG LÖSCHEN').trim();

    try { if (legacyKey && legacyKey !== key) localStorage.removeItem(legacyKey); } catch (_) {}

    const getPending = () => safeParse(localStorage.getItem(key), []);
    const savePending = (items) => {
      try { localStorage.setItem(key, JSON.stringify(items.slice(0, 12))); } catch (_) {}
    };
    const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));

    const renderPending = () => {
      if (!pendingWrap || !pendingGrid || root.dataset.showPending !== 'true') return;
      const items = getPending();
      if (!items.length) { pendingWrap.hidden = true; pendingGrid.innerHTML = ''; return; }
      pendingWrap.hidden = false;
      pendingGrid.innerHTML = items.map(item => {
        const stars = '★'.repeat(Math.max(1, Math.min(5, Number(item.rating) || 5))) + '☆'.repeat(5 - Math.max(1, Math.min(5, Number(item.rating) || 5)));
        return `<article class="zero-review-card" data-zero-pending-id="${escapeHtml(item.id)}"><div class="zero-review-card__top"><div class="zero-review-card__stars" style="color:var(--zr-accent)">${stars}</div></div><h3>${escapeHtml(item.title)}</h3><blockquote>${escapeHtml(item.body)}</blockquote><footer><div><strong>${escapeHtml(item.name)}</strong><span>${escapeHtml(item.product || 'ZAVO')}</span></div><time>${escapeHtml(item.date)}</time></footer><span class="zero-review-card__pending-status">${escapeHtml(pendingStatusText)}</span><button type="button" class="zero-review-card__remove" data-zero-pending-remove="${escapeHtml(item.id)}">${escapeHtml(pendingRemoveText)}</button></article>`;
      }).join('');
    };

    const showMessage = (text, ok = true) => {
      if (!message) return;
      message.hidden = false;
      message.textContent = text;
      message.className = `zero-reviews__js-message ${ok ? 'is-success' : 'is-error'}`;
    };

    const collect = () => {
      const fd = new FormData(form);
      const ratingText = fd.get('contact[Bewertung]') || '5 / 5';
      const rating = parseInt(String(ratingText), 10) || 5;
      return {
        id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
        rating,
        name: String(fd.get('contact[name]') || '').trim(),
        email: String(fd.get('contact[email]') || '').trim(),
        product: String(fd.get('contact[Produkt]') || '').trim(),
        order: String(fd.get('contact[Bestellnummer]') || '').trim(),
        title: String(fd.get('contact[Bewertungstitel]') || '').trim(),
        body: String(fd.get('contact[Bewertungstext]') || '').trim(),
        date: new Intl.DateTimeFormat(document.documentElement.lang || 'de-DE', {day:'2-digit', month:'2-digit', year:'numeric'}).format(new Date()),
        status: 'pending',
        pageUrl: location.href
      };
    };

    const prepareContactBody = (review) => {
      const bodyField = form?.querySelector('[data-zero-review-email-body]');
      const pageField = form?.querySelector('[data-zero-review-page-url]');
      if (pageField) pageField.value = location.href;
      if (!bodyField) return;

      const lines = [
        'ZERO REVIEWS — NEUE BEWERTUNG',
        '--------------------------------',
        `Bewertung: ${review.rating} / 5 Sterne`,
        `Name: ${review.name || '-'}`,
        `E-Mail: ${review.email || '-'}`,
        `Produkt: ${review.product || root.dataset.productHandle || 'Allgemeine Shop-Bewertung'}`,
        `Bestellnummer: ${review.order || '-'}`,
        `Titel: ${review.title || '-'}`,
        '',
        'Bewertungstext:',
        review.body || '-',
        '',
        `Veröffentlichung erlaubt: ${form.querySelector('input[name="contact[Veröffentlichung erlaubt]"]')?.checked ? 'Ja' : 'Nein'}`,
        `Datum: ${review.date}`,
        `Seite: ${location.href}`
      ];
      bodyField.value = lines.join('\n');
    };

    const renderExternal = (reviews) => {
      if (!externalGrid || !Array.isArray(reviews)) return;
      const approved = reviews.filter(item => !item.status || item.status === 'approved');
      if (!approved.length) return;
      externalGrid.hidden = false;
      if (emptyState) emptyState.hidden = true;
      externalGrid.innerHTML = approved.map(item => {
        const rating = Math.max(1, Math.min(5, Number(item.rating) || 5));
        const stars = Array.from({length:5}, (_, i) => `<span class="${i < rating ? 'is-active' : ''}">★</span>`).join('');
        const verified = item.verified ? '<span class="zero-review-card__verified">✓ VERIFIED</span>' : '';
        return `<article class="zero-review-card"><div class="zero-review-card__top"><div class="zero-review-card__stars">${stars}</div>${verified}</div>${item.title ? `<h3>${escapeHtml(item.title)}</h3>` : ''}<blockquote>${escapeHtml(item.body || item.quote || '')}</blockquote><footer><div><strong>${escapeHtml(item.name || 'ZAVO CUSTOMER')}</strong><span>${escapeHtml(item.meta || item.product || '')}</span></div>${item.date ? `<time>${escapeHtml(item.date)}</time>` : ''}</footer></article>`;
      }).join('');
      if (scoreBox) {
        const average = (approved.reduce((sum, item) => sum + Math.max(1, Math.min(5, Number(item.rating) || 5)), 0) / approved.length).toFixed(1);
        const rounded = Math.round(Number(average)); const scoreStars = Array.from({length:5}, (_, i) => `<span class="${i < rounded ? 'is-active' : ''}">★</span>`).join(''); scoreBox.innerHTML = `<strong>${average}</strong><div><div class="zero-reviews__score-stars">${scoreStars}</div><span>${approved.length} externe ${approved.length === 1 ? 'Bewertung' : 'Bewertungen'}</span></div>`;
      }
    };

    const loadExternal = async () => {
      if (mode !== 'external' || !endpoint) return;
      try {
        const url = new URL(endpoint, location.origin);
        const handle = root.dataset.productHandle || '';
        if (handle) url.searchParams.set('product', handle);
        const response = await fetch(url.toString(), {headers:{'Accept':'application/json'}});
        if (!response.ok) return;
        const payload = await response.json();
        renderExternal(Array.isArray(payload) ? payload : payload.reviews);
      } catch (_) {}
    };

    if (form) {
      form.addEventListener('submit', async (event) => {
        if (!form.checkValidity()) return;
        const review = collect();
        prepareContactBody(review);
        const items = getPending().filter(item => item.id !== review.id);
        items.unshift(review);
        savePending(items);
        renderPending();

        if (mode === 'local_only') {
          event.preventDefault();
          form.reset();
          const five = form.querySelector('input[name="contact[Bewertung]"][value^="5"]');
          if (five) five.checked = true;
          showMessage('Danke. Die Bewertung wurde auf diesem Gerät gespeichert. Für öffentliche Speicherung bitte Shopify Kontakt oder einen Backend Endpoint wählen.');
          return;
        }

        if (mode === 'external') {
          event.preventDefault();
          if (!endpoint) {
            showMessage('Kein Review Endpoint hinterlegt. Bitte im Theme-Editor einen Endpoint eintragen oder Shopify Kontakt wählen.', false);
            return;
          }
          try {
            const response = await fetch(endpoint, {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(review)});
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            form.reset();
            showMessage('Danke. Deine Bewertung wurde an das ZERO Reviews Backend übertragen.');
          } catch (error) {
            showMessage('Die Bewertung konnte nicht an den externen Speicher übertragen werden. Bitte später erneut versuchen.', false);
          }
        }
        // shopify_contact intentionally continues with the native form submit.
      });
    }


    const updateCount = () => {
      if (!bodyInput || !bodyCount) return;
      const max = Number(bodyInput.getAttribute('maxlength')) || 0;
      bodyCount.textContent = `${bodyInput.value.length}${max ? ` / ${max}` : ''}`;
    };
    bodyInput?.addEventListener('input', updateCount);
    updateCount();

    pendingGrid?.addEventListener('click', (event) => {
      const button = event.target.closest('[data-zero-pending-remove]');
      if (!button) return;
      const id = button.getAttribute('data-zero-pending-remove');
      savePending(getPending().filter(item => item.id !== id));
      renderPending();
      showMessage('Die lokale Testbewertung wurde gelöscht. Du kannst jetzt erneut testen.');
    });

    resetAll?.addEventListener('click', () => {
      try { localStorage.removeItem(key); if (legacyKey) localStorage.removeItem(legacyKey); } catch (_) {}
      renderPending();
      if (form) form.reset();
      updateCount();
      const five = form?.querySelector('input[name="contact[Bewertung]"][value^="5"]');
      if (five) five.checked = true;
      showMessage('Testdaten wurden zurückgesetzt. Du kannst jetzt eine neue Bewertung absenden.');
    });

    pendingClear?.addEventListener('click', () => { savePending([]); renderPending(); showMessage('Lokale Bewertung gelöscht. Du kannst erneut bewerten.'); });
    renderPending();
    loadExternal();
  };

  const boot = (scope = document) => scope.querySelectorAll('[data-zero-reviews]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot()); else boot();
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();
